import React from 'react';
import { CalendarMonthOutlined, WarningAmberRounded } from '@mui/icons-material';

// Reconocer solamente los formatos del sistema. Los demás mensajes se muestran completos.
export const getTurnoNotification = ({ envia, categoria, mensaje }) => {
  if (envia !== 'SUGI_SYSTEM' || categoria === 'facturacion' || typeof mensaje !== 'string') return null;

  const sinTecnico = mensaje.match(/^El turno (\d+) se creó sin técnico asignado\. (Revisá la disponibilidad del centro\.)$/);
  if (sinTecnico) {
    return { id: sinTecnico[1], title: 'Turno sin técnico', description: sinTecnico[2], warning: true, details: [] };
  }

  const desdeBot = mensaje.match(/^Un paciente cargó el turno (\d+) desde el bot\. (.*)$/s);
  if (!desdeBot) return null;

  const [, id, body] = desdeBot;
  const instruction = body.match(/(?:^|\. )(Revisá y (?:otorgalo|completá los datos)\.)$/);
  if (!instruction) return null;

  const data = body.slice(0, instruction.index);
  const details = [];
  if (data) {
    const fields = data.split(/ — (?=(?:Paciente|Estudio|Obra social|Fecha): )/);
    for (const field of fields) {
      const match = field.match(/^(Paciente|Estudio|Obra social|Fecha): (.+)$/s);
      if (!match) return null;
      details.push({ label: match[1], value: match[2] });
    }
  }

  return { id, title: 'Nuevo turno desde el bot', description: instruction[1], warning: false, details };
};

const TurnoNotification = ({ turno }) => (
  <div className={`notification-turno ${turno.warning ? 'notification-turno-warning' : ''}`}>
    <div className="notification-turno-heading">
      <span className="notification-turno-icon" aria-hidden="true">
        {turno.warning ? <WarningAmberRounded fontSize="small" /> : <CalendarMonthOutlined fontSize="small" />}
      </span>
      <div>
        <span className="notification-turno-number">Turno #{turno.id}</span>
        <h4>{turno.title}</h4>
      </div>
    </div>
    {turno.details.length > 0 && (
      <dl className="notification-turno-details">
        {turno.details.map(({ label, value }, index) => (
          <div key={`${label}-${index}`} className={label === 'Paciente' ? 'notification-turno-paciente' : ''}>
            <dt>{label}</dt>
            <dd>{value}</dd>
          </div>
        ))}
      </dl>
    )}
    <p className="notification-turno-description">{turno.description}</p>
  </div>
);

export default TurnoNotification;
